import React, { Component } from 'react';
import api from '../../services/api';
import ReCAPTCHA from "react-google-recaptcha";
import './styles.css';

api.interceptors.request.use(async config => {
    const USER_TOKEN = localStorage.getItem("token");

    if(USER_TOKEN) {   
        config.headers.Authorization = `Bearer ${USER_TOKEN}`;
    }
    return config;
});

class Main extends Component {
    state = {
        user: '',
        password: '',
        msgError: null,
        load: false, 
        // robot: false // true
        robot: true
    }

    componentDidMount() {
        if (!localStorage.getItem('token')) {
            this.loadUser();
        } else {
            window.location.href = './home';
        }
    }

    handleChangeUser = (e) => {
        this.setState({ user: e.target.value })
    }

    handleChangePass = (e) => {
        this.setState({ password: e.target.value })
    }

    loadUser = async () => {
        // const response = await api.get('/products');
        // this.setState({ products: response.data });
    }

    reCaptchaChange = (value) => {
        if (window.grecaptcha.getResponse().length > 0) 
            this.setState({ robot: false });
    }

    loginUser = async () => {
        this.setState({ msgError: null, load: true });

        // document.getElementById('loginform').onsubmit();
        await api.post(`/auth`, {
            email: this.state.user,
            password: this.state.password
        }).then(async (result) => {

           this.setState({ userLogin: result.data.user, token: result.data.token });
           localStorage.setItem('CompanyId', result.data.user.CompanyId);
            
            await api.get(`/companies/${localStorage.getItem('CompanyId')}`).then(async (result) => {

                localStorage.setItem('token', this.state.token);
                localStorage.setItem('name', this.state.userLogin.name);
                localStorage.setItem('email', this.state.userLogin.email);
                localStorage.setItem('userId', this.state.userLogin.id);
                localStorage.setItem('UserTypeId', this.state.userLogin.UserTypeId);
                localStorage.setItem('SectorId', this.state.userLogin.SectorId);

                localStorage.setItem('businessName', result.data.data.businessName);
                localStorage.setItem('cnpj', result.data.data.cnpj);
                localStorage.setItem('CompanyTypeId', result.data.data.CompanyTypeId);

                await api.get(`/companies?cnpj=${result.data.data.cnpj}`).then((result1) => {
                    if (result1.data.rows.length) {
                        localStorage.setItem('companyStatusId', result1.data.rows[0].CompanyStatus.id);
                        localStorage.setItem('companyStatus', result1.data.rows[0].CompanyStatus.description);
                    }
                });
            });

            window.location.href = './home';
            this.setState({ load: false });

        }).catch(error => {
            this.setState({ msgError: 'User or password incorrect.' });
            this.setState({ load: false });
        });
    }

    render() {
        return (
            <section id="wrapper">
                <div className="row back-login">
                    <div className="col-md-6 text-center logo">
                        <img className="col-md-6 div-logo" alt="DP World" src={require('./logo.fw.front.png')} />
                    </div>
                    <div className="col-md-6">
                        <form className="col-md-7 tesea" action="javascript:void(0)" id="loginform">
                            <div>
                                <div className="col-md-12">
                                    <label className="text-uppercase box-title">Usuário</label>
                                    {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                    <input className="form-control col-md-12" type="text" value={this.state.user} onChange={this.handleChangeUser} />
                                </div>
                                <div className="col-md-12">
                                    <label className="text-uppercase box-title">Senha</label>
                                    <input className="form-control col-md-12" id="pass" type="password" value={this.state.password} onChange={this.handleChangePass} />
                                </div>
                                 <div className="col-md-12">
                                    <ReCAPTCHA
                                        sitekey="6LfX7VgaAAAAACBHtF_quzB9Gh9KDtbZkNiFRzsA"
                                        onChange={this.reCaptchaChange}
                                    />
                                </div> 
                                {(this.state.msgError) ?
                                    <div className="col-md-12 m-t-20">
                                        <div className="alert alert-danger">
                                            {this.state.msgError}
                                        </div>
                                    </div>
                                    : null}

                                <div className="col-md-12 m-t-20">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <a href="/forgot-password">Esqueci a senha</a>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="col-md-12 btn btn-success text-uppercase" disabled={this.state.robot} onClick={this.loginUser}>
                                                Acessar
                                            </button>
                                        </div>
                                        <div className="col-md-12 text-center btn-create-company">
                                            <a href="/company" className="col-md-7 btn btn-warning text-uppercase">
                                                Cadastrar Empresa
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="alert alert-primary" style={{position:"absolute", fontSize:13, bottom:0, right:525, height:"75px", width:"500px"}}>
                <b>Cookies:</b> Este site faz o uso de cookies para avaliar as interações dos usuários (Google Analytics) visando melhorar a experiência entregue pela aplicação.<br></br>
                </div>

                <div className="alert alert-warning" style={{position:"absolute", fontSize:13, bottom:0, right:10, height:"75px", width:"500px"}}>
                Antes de acessar este website e/ou interagir com nossa plataforma, clique <a href="https://cdi.dpworldsantos.com/DPWS_Aviso_de_Privacidade.pdf" target="_blank">aqui</a> para ler e conhecer o Aviso de Privacidade da DP World Santos.
                </div>
            </section>
        )
    }
}

export default Main;